import { render, staticRenderFns } from "./welcome-message.vue?vue&type=template&id=5063d200&scoped=true&"
import script from "./welcome-message.vue?vue&type=script&lang=js&"
export * from "./welcome-message.vue?vue&type=script&lang=js&"
import style0 from "./welcome-message.vue?vue&type=style&index=0&id=5063d200&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5063d200",
  null
  
)

export default component.exports